// 计费服务 —— 额度、套餐、Stripe 结账
// 后端：Cloud Functions（functions/src/billing.ts + functions/src/stripe.ts）
import { type User } from 'firebase/auth';

export type PlanId = 'free' | 'basic';

export interface PlanOption {
  id: PlanId;
  name: string;
  priceCents: number;
  currency: string;
  monthlyCredits: number;
  features: string[];
}

export interface BillingAccount {
  balance: number;
  plan: PlanId;
  planName: string;
  planStatus: string;
  periodEnd: number | null;
  lifetimeGranted: number;
  lifetimeSpent: number;
  monthlyCredits: number;
  signupCredits: number;
  plans: PlanOption[];
}

export const API_BASE: string =
  ((import.meta as any).env?.VITE_API_BASE as string | undefined)?.replace(/\/+$/, '') ||
  'https://us-central1-meihua-16427.cloudfunctions.net';

async function apiFetch(path: string, init: RequestInit & { token: string }): Promise<any> {
  const response = await fetch(`${API_BASE}/api${path}`, {
    ...init,
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${init.token}` },
  });
  let data: any = {};
  try {
    data = await response.json();
  } catch {
    data = {};
  }
  if (!response.ok) {
    const err: any = new Error(data?.message || data?.error || `请求失败（${response.status}）`);
    err.code = data?.code;
    err.status = response.status;
    err.data = data?.data;
    throw err;
  }
  return data;
}

/** 查询额度与套餐 */
export async function fetchAccount(user: User): Promise<BillingAccount> {
  const data = await apiFetch('/billing/account', { method: 'GET', token: await user.getIdToken() });
  return data.data as BillingAccount;
}

/** 发起 Stripe Checkout，返回跳转地址 */
export async function startCheckout(user: User): Promise<string> {
  const data = await apiFetch('/billing/checkout', { method: 'POST', token: await user.getIdToken() });
  return data.data.url as string;
}

/** 打开 Stripe 账单门户（管理 / 取消订阅） */
export async function openBillingPortal(user: User): Promise<string> {
  const data = await apiFetch('/billing/portal', { method: 'POST', token: await user.getIdToken() });
  return data.data.url as string;
}

/** 额度不足时后端返回的错误码 */
export const INSUFFICIENT_CREDITS = 'INSUFFICIENT_CREDITS';
